import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="relative flex items-center justify-center bg-black text-white">
      <div className="absolute inset-0">
        <div
          className="absolute rounded-full"
          style={{
            top: "-30px",
            right: "0px",
            width: "150px",
            height: "91px",
            backgroundColor: "#C7184A",
            filter: "blur(64px)",
          }}
        ></div>
      </div>
      <div className="relative z-10 w-full px-4 mt-5">
        <Outlet />
      </div>
    </div>
  );
}
